import { render, staticRenderFns } from "./AssignmentTask.vue?vue&type=template&id=eda2205a&scoped=true&"
import script from "./AssignmentTask.vue?vue&type=script&lang=js&"
export * from "./AssignmentTask.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentTask.vue?vue&type=style&index=0&id=eda2205a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda2205a",
  null
  
)

export default component.exports